import { render } from "./benefits-current.vue?vue&type=template&id=52a69613"
import script from "./benefits-current.vue?vue&type=script&lang=js"
export * from "./benefits-current.vue?vue&type=script&lang=js"

import "./benefits-current.vue?vue&type=style&index=0&id=52a69613&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__